/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Field_Assistant_Prompt_Q2_C1Inputs */



/**
* | output |
* | --- |
* | "Ask me before going further" |
*
* @param {Uno_Field_Assistant_Prompt_Q2_C1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_field_assistant_prompt_q2_c1 = /** @type {((inputs?: Uno_Field_Assistant_Prompt_Q2_C1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Field_Assistant_Prompt_Q2_C1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erst bei mir nachfragen")
	return /** @type {LocalizedString} */ ("Ask me before going further")
});